import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  pageState,
  wizardEnableStep1State,
  wizardEnableStep2State,
  wizardEnableStep3State,
  wizardEnableStep4State
} from 'Pages/AbTestWizard/recoil/state/page'
import { changeWizardStepCallback } from 'Pages/AbTestWizard/recoil/callbacks/callbacks'

import { Wizard, SpacingVertical, SPACING_24 } from 'mailup-web-components'
import AbTestWizard1Step from 'Pages/AbTestWizard/components/AbTestWizard1Step'
import AbTestWizard2Step from 'Pages/AbTestWizard/components/AbTestWizard2Step'
import AbTestWizard3Step from 'Pages/AbTestWizard/components/AbTestWizard3Step'
import AbTestWizard4Step from 'Pages/AbTestWizard/components/AbTestWizard4Step'

const WizardContainer = () => {
  const intl = useIntl()
  const { wizardStep } = useRecoilValue(pageState)
  const enableStep1 = useRecoilValue(wizardEnableStep1State)
  const enableStep2 = useRecoilValue(wizardEnableStep2State)
  const enableStep3 = useRecoilValue(wizardEnableStep3State)
  const enableStep4 = useRecoilValue(wizardEnableStep4State)

  const changeWizardStep = useRecoilCallback(changeWizardStepCallback, [])

  const options = [
    {
      label: intl.formatMessage({ id: 'Load.ABTestWizard.Step1Tab' }),
      value: 1,
      enabled: enableStep1 && wizardStep !== 4
    },
    {
      label: intl.formatMessage({ id: 'Load.ABTestWizard.Step2Tab' }),
      value: 2,
      enabled: enableStep2 && wizardStep !== 4
    },
    {
      label: intl.formatMessage({ id: 'Load.ABTestWizard.Step3Tab' }),
      value: 3,
      enabled: enableStep3 && wizardStep !== 4
    },
    {
      label: intl.formatMessage({ id: 'Load.ABTestWizard.Step4Tab' }),
      value: 4,
      enabled: enableStep4
    }
  ]

  return (
    <>
      <Wizard
        value={wizardStep}
        options={options}
        onChange={changeWizardStep}
      />
      <SpacingVertical variant={SPACING_24} />
      {wizardStep === 1 && <AbTestWizard1Step />}
      {wizardStep === 2 && <AbTestWizard2Step />}
      {wizardStep === 3 && <AbTestWizard3Step />}
      {wizardStep === 4 && <AbTestWizard4Step />}
    </>
  )
}

export default WizardContainer
